import React from "react";

import { StyledSVG } from "../StyledIcon";

export const ObservabilityIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M10.8107 2.23896C9.60537 1.91599 8.33559 1.9211 7.13287 2.25377C5.93016 2.58644 4.83823 3.23458 3.97018 4.13105C3.10212 5.02753 2.48949 6.13976 2.19572 7.35257C1.90196 8.56538 1.93774 9.83466 2.29937 11.029C2.66099 12.2233 3.33531 13.2993 4.2525 14.1454C5.16968 14.9916 6.29638 15.5772 7.51593 15.8415C8.73548 16.1059 10.0035 16.0395 11.1888 15.6491C12.374 15.2588 13.4334 14.5586 14.2571 13.6213L8.99899 9.00045L10.8107 2.23896Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="8.99899"
        cy="9.00045"
        rx="7"
        ry="7"
        transform="rotate(-75 8.99899 9.00045)"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
